import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './components/Home';
import About from './components/About';
import Contact from './components/Contact';
import Login from './components/Login';
import Features from './components/Features';
import Dashboard from './components/Dashboard';
import SchoolDashboard from './components/SchoolDashboard';
import StudentDashboard from './components/StudentDashboard';
import 'bootstrap/dist/css/bootstrap.min.css';
import PrimeProgramme from "./components/PrimeProgramme";
import TechnoUniqueProgramme from "./components/TechnoUniqueProgramme";
import OlympiadProgramme from "./components/OlympiadProgramme";
import SampleCopy from "./components/SampleCopy";

const App = () => {
  return (
    <Router>
      
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/login" element={<Login />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/schooldashboard" element={<SchoolDashboard />} />
        <Route path="/studentdashboard" element={<StudentDashboard />} />
        <Route path="/features" element={<Features />} />
        <Route path="/prime" element={<PrimeProgramme />} />
        <Route path="/techno" element={<TechnoUniqueProgramme />} />
        <Route path="/olympiad" element={<OlympiadProgramme />} />
        <Route path="/sample-copy" element={<SampleCopy />} />
      </Routes>
    </Router>
  );
};

export default App;
